export const Deadline = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_284_15596)">
      <path
        d="M12.25 1.18229H10.5V0.015625H9.33333V1.18229H4.66667V0.015625H3.5V1.18229H1.75C0.785167 1.18229 0 1.96746 0 2.93229V14.0156H14V2.93229C14 1.96746 13.2148 1.18229 12.25 1.18229ZM1.75 2.34896H12.25C12.5714 2.34896 12.8333 2.61087 12.8333 2.93229V4.68229H1.16667V2.93229C1.16667 2.61087 1.42858 2.34896 1.75 2.34896ZM1.16667 12.849V5.84896H12.8333V12.849H1.16667ZM9.81167 8.95871L8.40758 9.99879L8.9425 11.6432L8.42742 11.995L7.00525 11.0307L5.57083 12.0025L5.09367 11.6339L5.60117 9.98129L4.22508 8.98146L4.31958 8.47221H6.12908L6.64767 6.66329H7.32842L7.87908 8.47221H9.67925L9.81108 8.95929L9.81167 8.95871Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_284_15596">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
